import { MAP_TYPES } from '@deck.gl/carto';

const CUSTOMSQL_THIRD_SOURCE_ID = 'customSqlThirdSource';

const source = {
  id: CUSTOMSQL_THIRD_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: undefined,
  data: undefined,
};

export default source;
